// extracted by mini-css-extract-plugin
module.exports = {"form":"form___372Cw","disclaimer":"disclaimer___3L77H","error":"error___34P-q"};